import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import CustomIcon from '../common/CustomIcon';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import * as bookActions from '../../actions/bookActions';
import * as libraryActions from '../../actions/libraryActions';
import * as messageAlert from '../../actions/messageAlertAction';
import * as drawerActions from '../../actions/drawerActions';
import { BottomSheet, BottomSheetAction, BoxButton } from '@netexknowledge/smart-components';
import { ROUTES } from '../../const';
import routerHistory from '../../routerHistory';
import { EMPTY_LESSON_ID } from '../../config_module';
import { ANALYTICS_CONTEXT } from '../../types/analytics';
import { useState } from 'react';

class NewLessonPanel extends React.Component {
  static propTypes = {
    drawerActions: PropTypes.any,
    newLessonUnitIdRef: PropTypes.any,
    bookActions: PropTypes.any,
    libraryActions: PropTypes.any,
    bookId: PropTypes.string,
    unitActivityId: PropTypes.string,
    hideImportSelfExecutableButton: PropTypes.bool,
    hideImportLessonButton: PropTypes.bool,
    // 'sheet': mobile bottom sheet instead of the right drawer layout
    variant: PropTypes.oneOf(['drawer', 'sheet'])
  };

  constructor(props, context) {
    super(props, context);
    this.openLinkDialog = this.openLinkDialog.bind(this);
    this.openUploadDialog = this.openUploadDialog.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.state = {
      disabled: false,
      name: I18n.t('lessonLeftPanel.addNewLesson')
    };
    this.importEmptyLesson = this.importEmptyLesson.bind(this);
  }

  closePanel() {
    const { drawerActions } = this.props;
    drawerActions.closeDrawerAndRemoveContent();
  }

  openUploadDialog() {
    const { newLessonUnitIdRef } = this.props;
    newLessonUnitIdRef.open();
    this.closePanel();
  }

  openLinkDialog() {
    this.props.bookActions.setIsLinkLessonModalOpen(true);
    this.closePanel();
  }

  openAutoExecDialog = () => {
    this.props.bookActions.setIsAutoExecLessonModalOpen(true);
    this.closePanel();
  };

  openImportLessonDialog = () => {
    const { classroom, bookId, unitActivityId } = this.props;
    const libraryUrl = `${ROUTES.CLASSROOM}/${classroom.id}/book/${bookId}/library?creating=lesson&unitActivityId=${unitActivityId}`;
    routerHistory.push(libraryUrl);
    this.closePanel();
  };

  importEmptyLesson = () => {
    const { classroom, bookId, unitActivityId } = this.props;
    const lessonActivityIds = [EMPTY_LESSON_ID];
    this.props.libraryActions.importLessonsToUnitClassroom(classroom, bookId, unitActivityId, lessonActivityIds, ANALYTICS_CONTEXT.EMPTY_LESSON_CREATE);

    //Cambio de estado a disabled del botón Crear lección vacía
    this.setState(prevState => ({
      disabled: true,
      name: this.state.disabled ? I18n.t('lessonLeftPanel.addNewLesson') : I18n.t('lessonLeftPanel.addingNewLesson')
    }));
  };

  renderHeader() {
    return (
      <div className="header">
        <Link className="close" onClick={this.closePanel.bind(this)}>
          <CustomIcon name="close-button" size={24} />
        </Link>
        <span>{I18n.t('rightPanel.newLesson.addContent')}</span>
      </div>
    );
  }

  // Mobile: same options as the drawer, as rows of a bottom sheet
  renderSheet() {
    const { hideImportSelfExecutableButton, hideImportLessonButton } = this.props;

    return (
      <BottomSheet
        open
        onClose={this.closePanel}
        closeLabel={I18n.t('common.close')}
        title={I18n.t('rightPanel.newLesson.addContent')}
      >
        <BottomSheetAction
          icon={<i className="custom-icons-school-paper-clip" />}
          label={I18n.t('lessonLeftPanel.addFile')}
          onClick={this.openUploadDialog}
        />
        <BottomSheetAction
          icon={<i className="custom-icons-link" />}
          label={I18n.t('lessonLeftPanel.addLink')}
          onClick={this.openLinkDialog}
        />
        {!hideImportLessonButton && (
          <BottomSheetAction
            icon={<i className="custom-icons-export-file" />}
            label={I18n.t('lessonLeftPanel.addLesson')}
            navigates
            onClick={this.openImportLessonDialog}
          />
        )}
        {!hideImportLessonButton && (
          <BottomSheetAction
            icon={<i className="custom-icons-add-content" />}
            label={this.state.name}
            disabled={this.state.disabled}
            onClick={this.importEmptyLesson}
          />
        )}
        {!hideImportSelfExecutableButton && (
          <BottomSheetAction
            icon={<i className="custom-icons-add-content" />}
            label={I18n.t('autoExec.autoExec')}
            onClick={this.openAutoExecDialog}
          />
        )}
      </BottomSheet>
    );
  }

  render() {
    const { hideImportSelfExecutableButton, variant } = this.props;

    if (variant === 'sheet') {
      return this.renderSheet();
    }

    return (
      <div className="right-panel-new" ref="newLessonPanel" id="new-lesson-panel">
        <div className="content">
          {this.renderHeader()}
          <div className="heading1">
            <span>{I18n.t('rightPanel.newBook.chooseType')}</span>
          </div>
          <div className="add-resource-panel-buttons">
            <div className="add-resource-panel-buttons__one-item">
              <BoxButton
                id="addFile"
                label={I18n.t('lessonLeftPanel.addFile')}
                icon="custom-icons-school-paper-clip"
                onClick={this.openUploadDialog}
              />
            </div>
            <div className="add-resource-panel-buttons__one-item">
              <BoxButton
                id="addLink"
                label={I18n.t('lessonLeftPanel.addLink')}
                icon="custom-icons-link"
                onClick={this.openLinkDialog}
              />
            </div>
            {!this.props.hideImportLessonButton && (
              <div className="add-resource-panel-buttons__one-item">
                <BoxButton
                  id="addLesson"
                  label={I18n.t('lessonLeftPanel.addLesson')}
                  icon="custom-icons-export-file"
                  onClick={this.openImportLessonDialog}
                />
              </div>
            )}
            {!this.props.hideImportLessonButton && (
              <div className="add-resource-panel-buttons__one-item">
                <BoxButton
                  id="emptyLesson"
                  label={this.state.name}
                  disabled={this.state.disabled}
                  icon="custom-icons-add-content"
                  onClick={this.importEmptyLesson}
                />
              </div>
            )}
            {!hideImportSelfExecutableButton && (
              <div className="add-resource-panel-buttons__one-item">
                <BoxButton
                  id="autoExecutableLesson"
                  label={I18n.t('autoExec.autoExec')}
                  icon="custom-icons-add-content"
                  onClick={this.openAutoExecDialog}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    newLessonUnitIdRef: state.book.newLessonUnitIdRef,
    unitActivityId: state.book.newLessonUnitId,
    classroom: state.classrooms.selectedClassroom.classroom,
    hideImportSelfExecutableButton: state.account.configuration.hideImportSelfExecutableButton,
    hideImportLessonButton: state.account.configuration.hideImportLessonButton
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    libraryActions: bindActionCreators(libraryActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewLessonPanel);
